import script from "./ApButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./ApButton.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__